import { first, orderBy, filter, groupBy, omit, toPairs, fromPairs, some, find } from 'lodash';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { NgForm } from '@angular/forms';
import { Component, ViewEncapsulation, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import SelfPay from 'src/app/models/selfPay';
import Plan from 'src/app/models/plan';
import { env } from 'src/env/development';
import Agency from 'src/app/models/agency';
import * as dayjs from 'dayjs';
import SelfPayFormDependent from 'src/app/models/selfPayFormDependent';
import { CoreService } from 'src/app/services/core.service';
import Subscriber from 'src/app/models/subscriber';
import { Lookups, LookupType } from 'src/app/decorators/lookups.decorator';
import PlanType from 'src/app/models/planType';
import { ActivatedRoute } from '@angular/router';

@Lookups(LookupType.PlanType)
@Component({
  selector: 'self-pay-elect-dental',
  templateUrl: 'selfPay.electDental.component.html',
  styleUrls: [],
  providers: [],
  encapsulation: ViewEncapsulation.None
})
export class SelfPayElectDentalComponent implements OnInit {
  @Output() saveSelfPay: EventEmitter<SelfPay> = new EventEmitter<SelfPay>();
  @Output() previous: EventEmitter<void> = new EventEmitter();
  @ViewChild('electDentalForm') public electDentalForm: NgForm;
  @Input() selfPay: SelfPay;
  @Input() availablePlans: Plan[];
  @Input() agency: Agency;
  @Input() subscriber: Subscriber;
  dentalPlans: Plan[];
  groupedDentalPlans: {[k: string]: Plan[]};
  selectedPlanId: string;
  env = env;
  noDentalSelectionMade = false;
  lookups = { planTypes: [] };

  constructor(private route: ActivatedRoute,
    private coreService: CoreService) {}
  
  ngOnInit(): void {
    this.lookups.planTypes = this.route.snapshot.data.lookups.planTypes;
    this.dentalPlans = filter(this.availablePlans, (ap) => ap.planType?.planTypeCode === '2' && !ap.planTypeDefaultPlanInd && ap.agencyId === this.agency.agencyId);
    this.noDentalSelectionMade = !this.selfPay?.formJson?.subscriber?.dentalEnrollInd && !some(this.selfPay?.formJson?.dependents, (d: SelfPayFormDependent) => d.dentalCoverInd);
    // the only dental plan without a carrier is the default placeholder plan. This removes that plan from list.
    this.groupedDentalPlans = (omit(groupBy(this.dentalPlans, 'carrier.carrierName'), 'undefined'));
    this.groupedDentalPlans = {
      'Preferred Provider Organization (PPO)' : this.groupedDentalPlans[`Preferred Provider Organization (PPO)`],
      'Managed-care plans (limited network)' : this.groupedDentalPlans[`Managed-care plans (limited network)`]
    };

    if (this.selfPay.formJson.dentalPlan && Object.keys(this.selfPay.formJson.dentalPlan).length > 0) {
      this.selectedPlanId = this.selfPay.formJson.dentalPlan.planId;
    } else if (this.selfPay.isPEBB && this.selfPay.isCobraSOE) {
      var enrollments = this.subscriber.enrollments.filter(e =>
        e.plan.planType.planTypeCode === env.dentalPlanTypeCode &&
        e.isActive(this.selfPay.coverageEffectiveDate ?? new Date())
      );

      if (enrollments.length)
        this.selectedPlanId = enrollments[0].planId;
    }
  }

  setPlan(planId): void {
    this.selfPay.formJson.dentalPlan = find(this.availablePlans, (p: Plan) => p.planId === planId);

    this.selfPay.formJson.continueCurrentSelectedDental = false;
  }

  emitSelfPay(e): void {
    this.saveSelfPay.emit(e);
  }

  continueCurrentSelected(checked) {
    if(checked) {
      this.selfPay.formJson.continueCurrentSelectedDental = true;
      this.selfPay.formJson.dentalPlan = null;
      this.selectedPlanId = null;
    }
  }

  continueToNextStep() {
    if (!this.noDentalSelectionMade) {
      if (this.selfPay.isRetiree || (this.selfPay.isPEBB && this.selfPay.isCobraOE)) {
        if (!this.selectedPlanId && !this.selfPay?.formJson?.continueCurrentSelectedDental) {
          this.coreService.popMessage('A single plan must be selected', 'error', 5000);
          return;
        }
      }
    }

    if (this.selfPay?.formJson?.continueCurrentSelectedDental) {
      const dentalPlanTypeId = first(this.lookups.planTypes.filter((pt: PlanType) => pt.planTypeCode === env.dentalPlanTypeCode)).planTypeId;
      this.selfPay.formJson.dentalPlan = first(orderBy(this.subscriber.enrollments.filter(e => e.planTypeId === dentalPlanTypeId), 'effectiveStartDate', 'desc'))?.plan;
    }

    this.saveSelfPay.emit(this.selfPay);
  }
}
